import { useSyncExternalStore } from 'react';

/**
 * `(hover: hover)` pergunta pelo **ponteiro principal** do aparelho, e é
 * exatamente a pergunta que interessa: faz sentido esta tela ter dica que
 * aparece ao pairar?
 *
 * No celular a resposta é não, e é por isso que a consulta não é largura de
 * tela: um notebook com tela sensível ao toque continua tendo mouse, e quem o
 * usa continua pairando. Medir por pixels acertaria o celular e erraria ele.
 */
const CONSULTA = '(hover: hover)';

function observar(aoMudar: () => void) {
  const media = window.matchMedia(CONSULTA);
  media.addEventListener('change', aoMudar);
  return () => media.removeEventListener('change', aoMudar);
}

/**
 * Se o aparelho tem ponteiro que paira.
 *
 * Também muda com a página aberta - um tablet que ganha teclado com trackpad
 * troca de resposta -, e é por isso que é assinatura, e não uma leitura só na
 * montagem.
 */
export function useTemHover() {
  return useSyncExternalStore(observar, () => window.matchMedia(CONSULTA).matches, () => true);
}
